module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "titlepage"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('i', [_vm._v("Back in"), _c('br'), _vm._v("Charge!")])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("A Guide to Harnessing"), _c('br'), _vm._v("the Magic of Your Brain"), _c('br'), _vm._v("to Create the Life You’ll Love")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("DRIANNE")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HERN")]), _vm._v(", P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("H")]), _vm._v(".D.")]), _vm._v(" "), _c('p', {
    staticClass: "editor"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-decbce76","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Titlepage.vue
// module id = 63
// module chunks = 0